const WaterData = [
    {
        id : "1",
        schemeName: "Jal Jeevan Mission",
        discription:"Jal Jeevan Mission, is envisioned to provide safe and adequate drinking water through individual household tap connections by 2024 to all households in rural India. ",
        launchDate: "15 August 2019",
        AnualFund: "12345"

    },
   {id : "2",
    schemeName: "Jal Shakti Abhiyan",
    discription:"Ministry of Jal Shakti is taking up a nation-wide campaign “Jal Shakti Abhiyan: Catch the Rain” (JSA:CTR) focusing on saving and conserving rainwater with the theme “Source sustainability for drinking water” from 04 March 2023 to 30 November 2023 in the pre-monsoon and monsoon periods of 2023, covering both urban and rural areas of all the districts in the country. In this year key focus of JSA:CTR - 2023 is on ensuring source sustainability in 150 water stressed district of country, identified by Jal Jeevan Mission",
    launchDate: "02 March 2021",
    AnualFund: "12345"},
   

    {id : "3",
    schemeName: "Atal Bhujal Yojana",
    discription:"Atal Bhujal Yojana (Atal Jal) is targeted at sustainable groundwater management, mainly through convergence among various ongoing schemes with the active involvement of local communities and stakeholders. This will ensure that in the Scheme area, the funds allocated by the Central and State governments are spent judiciously to ensure the long term sustainability of groundwater resources",
    launchDate: "05 December 2019",
    AnualFund: "12345"},
   
    {
    id : "4",
        schemeName: "Namami Gange Programme",
        discription:"The National Mission for Clean Ganga (NMCG) was implemented by the National Council for Rejuvenation, Protection and Management of River Ganga also known as the National Ganga Council. This mission was established in 12th August 2011 under the Societies Registration Act,1860 as a registered society.",
        launchDate: "12 August 2011",
        AnualFund: "12345"
    },
   { id : "5",
    schemeName: "National Aquifer Mapping Programme",
    discription:"The National Aquifer Mapping and Management program (NAQUIM) is a crucial initiative being implemented by the Central Ground Water Board (CGWB) in India. The program aims to map aquifers, which are water-bearing formations, and develop Aquifer Management Plans to facilitate sustainable management of groundwater resources. ",
    launchDate: "Year 2012", 
     AnualFund: "12345"},
   

 {   id : "6",
    schemeName: "PM Krishi Sinchayee Yojana ",
    discription:"The Pradhan Mantri Krishi Sinchayee Yojana (PMKSY) was introduced with a vision of expanding irrigation coverage (Har Khet ko Pani) and using the water more efficiently (More Crop Per Drop)",
    launchDate: "1 July 2015",
    AnualFund: "12345"
},
]

export default WaterData;